/** Last stop before anything is sent: totals, journal count, and the three checks. */
import { money, type Run, type ValidateResult } from "../../payroll/api";

export default function ConfirmModal({
  run, dryRun, onCancel, onConfirm,
}: { run: Run; dryRun: ValidateResult | null; onCancel: () => void; onConfirm: () => void }) {
  const lines = run.journals.reduce((a, j) => a + j.lines.length, 0);
  const balanced = run.journals.every((j) => Math.abs(j.lines.reduce((a, l) => a + l.amount, 0)) < 0.005);
  const alreadyPosted = run.journals.some((j) => j.status === "draft_created");

  return (
    <div className="modal-scrim" role="dialog" aria-modal="true" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>Submit {run.journals.length} draft journals to iplicit?</h3>
        <p className="muted">
          Period <strong>{run.periodCode}</strong> · {run.monthLabel} · legal entity {run.entity} · doc date {run.runDate}
        </p>

        <dl className="confirm-figures">
          <div><dt>Journals</dt><dd>{run.journals.length}</dd></div>
          <div><dt>Journal lines</dt><dd>{lines}</dd></div>
          <div><dt>Gross pay</dt><dd>{money(run.totals.gross)}</dd></div>
          <div><dt>Total employer cost</dt><dd>{money(run.totals.employerCost)}</dd></div>
          <div><dt>Net pay to bank</dt><dd>{money(run.totals.netPay)}</dd></div>
        </dl>

        <ul className="confirm-checks">
          <li className={balanced ? "ok" : "bad"}>
            {balanced ? "✓" : "✕"} Balance check — every journal nets to zero
          </li>
          <li className={dryRun ? (dryRun.ok ? "ok" : "bad") : "warn"}>
            {dryRun ? (dryRun.ok ? "✓ Dry run passed against iplicit" : `✕ Dry run found ${dryRun.problems.length} problem(s)`) : "○ No dry run yet — you can submit without one"}
          </li>
          <li className={alreadyPosted ? "bad" : "ok"}>
            {alreadyPosted
              ? `✕ Duplicate guard — period ${run.periodCode} already has drafts in iplicit`
              : `✓ Duplicate guard — nothing submitted for period ${run.periodCode} yet`}
          </li>
        </ul>

        <p className="muted">
          Posted as <strong>unposted drafts</strong>. You review and post them inside iplicit.
        </p>

        <div className="modal__actions">
          <button className="btn" onClick={onCancel}>Cancel</button>
          <button className="btn btn--primary" disabled={!balanced || alreadyPosted} onClick={onConfirm}>
            Submit {run.journals.length} journals
          </button>
        </div>
      </div>
    </div>
  );
}
